import { Button } from '@ghs/components';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import AutorenewOutlinedIcon from '@mui/icons-material/AutorenewOutlined';
import { Box, CircularProgress, Container, Stack, Typography } from '@mui/material';
import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router-dom';
import { $$refreshKnowledgeBaseUtils } from './model';

export default function GhsAdminRefreshKnowledgeBasePage() {
  const navigate = useNavigate();
  const isRefreshKnowledgeBaseMtPending = useUnit($$refreshKnowledgeBaseUtils.$isRefreshKnowledgeBaseMtPending);
  const isRefreshKnowledgeBaseStResellersPending = useUnit($$refreshKnowledgeBaseUtils.$isRefreshKnowledgeBaseStResellersPending);

  return (
    <Container id="refresh-kb-utility-container">
      <Stack spacing={3}>
        <Button color="primary" size="medium" variant="text" sx={{ alignSelf: 'flex-start', pl: 0 }} startIcon={<ArrowBackRoundedIcon />} onClick={() => navigate('/ghsAdmin/utils')}>
          Back to Internal Utilities
        </Button>

        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: 2,
              bgcolor: 'action.hover',
              color: 'primary.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <AutorenewOutlinedIcon />
          </Box>
          <Typography variant="h4" color="text.primary">
            Refresh KB docs
          </Typography>
        </Stack>

        <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', maxWidth: 720 }}>
          <Typography variant="h5" color="text.primary" sx={{ p: 3, borderBottom: '1px solid', borderColor: 'divider' }}>
            Refresh Knowledge Base
          </Typography>
          <Stack spacing={2} sx={{ p: 3, maxWidth: 420 }}>
            <Typography variant="body1" color="text.secondary">
              Select the knowledge base index to refresh.
            </Typography>
            <Button
              color="primary"
              onClick={() => $$refreshKnowledgeBaseUtils.refreshKnowledgeBaseMtButtonClicked()}
              size="medium"
              variant="contained"
              disabled={isRefreshKnowledgeBaseMtPending}
            >
              Refresh Knowledge Base - MT
              {isRefreshKnowledgeBaseMtPending && <CircularProgress size={16} color="inherit" sx={{ ml: 1 }} />}
            </Button>
            <Button
              color="primary"
              onClick={() => $$refreshKnowledgeBaseUtils.refreshKnowledgeBaseStResellersButtonClicked()}
              size="medium"
              variant="contained"
              disabled={isRefreshKnowledgeBaseStResellersPending}
            >
              Refresh Knowledge Base - ST Resellers
              {isRefreshKnowledgeBaseStResellersPending && <CircularProgress size={16} color="inherit" sx={{ ml: 1 }} />}
            </Button>
          </Stack>
        </Box>
      </Stack>
    </Container>
  );
}
